import { render } from "./BaseNotification.vue?vue&type=template&id=1effb630&scoped=true"
import script from "./BaseNotification.vue?vue&type=script&lang=js"
export * from "./BaseNotification.vue?vue&type=script&lang=js"

import "./BaseNotification.vue?vue&type=style&index=0&id=1effb630&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1effb630"]])

export default __exports__